import { SpacingOptions } from "@material-ui/core/styles/createSpacing"

const spacing: SpacingOptions = 8

export default spacing
